import {DirectoryState} from './types';

export const initialState: DirectoryState = {};
